import { render, staticRenderFns } from "./LsAccordion.vue?vue&type=template&id=0e8c6d75&scoped=true&"
import script from "./LsAccordion.vue?vue&type=script&lang=js&"
export * from "./LsAccordion.vue?vue&type=script&lang=js&"
import style0 from "./LsAccordion.vue?vue&type=style&index=0&id=0e8c6d75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8c6d75",
  null
  
)

export default component.exports